import type { Ceremony, CeremonyRole, WeddingData } from '@/mock/types'

export const ceremonyKindLabels: Record<NonNullable<Ceremony['kind']>, string> = {
  civil: 'Civilní obřad',
  religious: 'Církevní obřad',
  symbolic: 'Symbolický obřad',
}

export function ceremonySummary(data: WeddingData) {
  const ceremony = data.ceremony
  const event = data.schedule.find((item) => item.source?.section === 'ceremony')
  const guests = data.parties.flatMap((party) =>
    party.persons.map((person) => ({
      id: person.id,
      name: `${person.firstName} ${person.lastName}`.trim(),
      partyId: party.id,
    })),
  )
  return {
    event,
    venue: data.suppliers.find((supplier) => supplier.id === ceremony.venueSupplierId),
    officiant: data.suppliers.find((supplier) => supplier.id === ceremony.officiantSupplierId),
    brideWitness: guests.find((guest) => guest.id === ceremony.brideWitnessId),
    groomWitness: guests.find((guest) => guest.id === ceremony.groomWitnessId),
    planBDecider: data.members.find((member) => member.id === ceremony.planB?.decisionByMemberId),
  }
}

export function ceremonyPerson(person: CeremonyRole['person'], data: WeddingData) {
  if (!person) return undefined
  if (person.type === 'guest') {
    const party = data.parties.find((party) =>
      party.persons.some((guest) => guest.id === person.id),
    )
    const guest = party?.persons.find((guest) => guest.id === person.id)
    return party && guest
      ? {
          name: `${guest.firstName} ${guest.lastName}`.trim() || 'Doprovod',
          to: `/guests/${party.id}`,
        }
      : undefined
  }
  if (person.type === 'supplier') {
    const supplier = data.suppliers.find((supplier) => supplier.id === person.id)
    return supplier ? { name: supplier.name, to: `/suppliers/${supplier.id}` } : undefined
  }
  const member = data.members.find((member) => member.id === person.id)
  return member ? { name: member.name } : undefined
}
